import React from "react";
import { Hexagon, AlertTriangle } from "lucide-react";

export default function SetupNeeded() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="w-full max-w-2xl">
        <div className="flex items-center justify-center gap-3 mb-8">
          <Hexagon size={32} className="text-sky-400" strokeWidth={2.5} />
          <div>
            <div className="serif text-2xl font-bold text-stone-900 leading-none">
              Tax Planning Workbench
            </div>
            <div className="sans text-[10px] uppercase tracking-widest text-stone-500 mt-1">
              Linked Accounting LLP
            </div>
          </div>
        </div>

        <div className="bg-white border border-amber-300 rounded-sm p-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="flex items-center justify-center w-10 h-10 bg-amber-100 rounded-full">
              <AlertTriangle size={20} className="text-amber-700" />
            </div>
            <div className="serif text-xl font-bold text-stone-900">
              Supabase not configured
            </div>
          </div>

          <div className="sans text-sm text-stone-700 mb-4 leading-relaxed">
            This deployment is missing the Supabase environment variables. Set both of
            these in <strong>Cloudflare Pages → Settings → Environment Variables</strong>{" "}
            (or in <code className="mono">.env.local</code> for local dev):
          </div>

          <div className="bg-stone-900 text-stone-100 px-4 py-3 rounded-sm mono text-sm space-y-1 mb-4">
            <div>VITE_SUPABASE_URL=https://&lt;project&gt;.supabase.co</div>
            <div>VITE_SUPABASE_ANON_KEY=eyJ...</div>
          </div>

          <div className="sans text-sm text-stone-700 leading-relaxed">
            Find these values in your Supabase project dashboard at{" "}
            <strong>Settings → API</strong>. Use the <em>anon public</em> key, never the{" "}
            <code className="mono">service_role</code> key. After saving the env vars,
            redeploy (Cloudflare auto-rebuilds on env-var save).
          </div>

          <div className="sans text-xs text-stone-500 mt-6 leading-relaxed">
            Setup steps including the schema SQL are in <code className="mono">README.md</code>.
          </div>
        </div>
      </div>
    </div>
  );
}
